import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { IArticle } from '../models/IArticle.type';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class DataService {
    private baseUrl = `${environment.baseUrl}${environment.api.articles}`;
    private baseArticlesBody = `${environment.baseUrl}${environment.api.articlesBody}`;
    //private baseArticleDetails = `${environment.baseUrl}${environment.api.articlesBody}`;
    private baseLatestArticles = `${environment.baseUrl}${environment.api.articlesLatest}`;
    private baseArticlesByCategory = `${environment.baseUrl}${environment.api.articlesByCategory}`;
    private baseGuideUrl = `${environment.baseUrl}${environment.api.guides}`;

    private headers = new Headers();
    
    constructor(private http: HttpClient){

        this.headers = new Headers();
        this.headers.set('Access-Control-Allow-Origin', '*');
        this.headers.set('Access-Control-Allow-Headers', 'Content-Type, application/json');
        this.headers.set('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE,PATCH,OPTIONS');
    }


    //List of Guide
    getGuides(): Observable<any>{
        return this.http.get<IArticle[]>(`${this.baseGuideUrl}`);
    }
    
    //List of Articles
    getArticles(): Observable<IArticle[]>{
        return this.http.get<IArticle[]>(`${this.baseUrl}`);
    }

    //Single Article By ID
    getArticle(id: number): Observable<any>{
        return this.http.get<any>(this.baseUrl + '/' + id);
    }

    //List of Articles By Category
    getArticlesByCategory(category: string): Observable<any>{
        return this.http.get<any>(this.baseArticlesByCategory, {
            params: new HttpParams()
            .set('category', category)
          });
    }

    //Latest Article By ID
    getLatestArticle(number: number): Observable<any>{
        return this.http.get<any>(this.baseLatestArticles, {
            params: new HttpParams()
            .set('number', number)
          });
    }

    handleError(error: HttpErrorResponse){
        return throwError(error);
    }

}